<app-tabs>
  <app-tab title="Asset">
    <div class="row">
      <div class="col-md-4">
        <label for="asset">Asset Name / Registration</label>
        <input
          type="text"
          name='asset'
          [(ngModel)]='this.vehicle.registration'
          [class.is-valid]='this.vehicle.registration !== ""'
          [class.is-invalid]='this.vehicle.registration === ""'
          class="form-control"
          [readOnly]='!this.editToggle'
          id="asset">
      </div>
      <div class="col-md-4">
        <label for="assetSerial">Serial No.</label>
        <input
          type="text"
          name='assetSerial'
          [(ngModel)]='this.vehicle.asset.assetSerial'
          class="form-control"
          [readOnly]='!this.editToggle'
          id="assetSerial">
      </div>
      @if (!this.formSettings.isVehicle) {
        <div class="col-md-4">
          <label for="make">Make</label>
          <input
            type="text"
            name='make'
            [(ngModel)]='this.vehicle.asset.make'
            class="form-control"
            [readOnly]='!this.editToggle'
            id="make">
        </div>
      }
      @if (!this.formSettings.isVehicle) {
        <div class="col-md-4">
          <label for="model">Model</label>
          <input
            type="text"
            name='model'
            [(ngModel)]='this.vehicle.asset.model'
            class="form-control"
            [readOnly]='!this.editToggle'
            id="model">
        </div>
      }
      <div class="col-md-8">
        <label for="description">Description</label>
        <textarea name="description" class='form-control' [(ngModel)]='this.vehicle.asset.description'></textarea>
      </div>
      <div class="col-md-4">
        <label>Asset Category</label>
        @if (this.formSettings.isVehicle || this.vehicle.asset.categoryId === 1) {
          <input class='form-control' type="text" value='Vehicle' readOnly/>
        }
        @if (!this.formSettings.isVehicle && this.vehicle.asset.categoryId !== 1) {
          <select class='form-control' [class.is-invalid]='this.vehicle.asset.categoryId === -1' (change)='this.changeCategory($event)'>
            <option value='-1'>Select a Category</option>
            @for (item of this.categories; track item) {
              <option
                [disabled]='item.id === 1'
                [value]='item.id'
                [selected]='this.vehicle.asset.categoryId === item.id'
              >{{ item.name }}</option>
            }
          </select>
        }
      </div>
      <div class="col-md-4">
        <label for="value">Value (£)</label>
        <input
          type="number"
          name='value'
          [(ngModel)]='this.vehicle.asset.value'
          class="form-control"
          [readOnly]='!this.editToggle'
          id="value">
      </div>
      @if (!this.formSettings.isVehicle) {
        <div class="col-md-4">
          <label for="dateOfRegistration">Date of First Registration</label>
          <input
            type="date"
            name='dateOfRegistration'
            [(ngModel)]='this.vehicle.asset.dateOfRegistration'
            class="form-control"
            [readOnly]='!this.editToggle'
            id="dateOfRegistration">
        </div>
      }
      @if (!this.formSettings.isVehicle) {
        <div class="col-md-4">
          <label for="purchaseDate">Purchase Date</label>
          <input
            type="date"
            name='purchaseDate'
            [(ngModel)]='this.vehicle.asset.purchaseDate'
            class="form-control"
            [readOnly]='!this.editToggle'
            id="purchaseDate">
        </div>
      }
      @if (!this.formSettings.isVehicle) {
        <div class="col-md-4">
          <label>Depot</label>
          <select
            class='form-control'
            (change)='this.changeDepot($event)'
            >
            <option value='-1'>No Depot</option>
            @for (depot of this.depots; track depot) {
              <option
                [value]='depot.id'
                [selected]='this.vehicle.asset.depotId === depot.id'
                >
                {{ depot.name }}
              </option>
            }
          </select>
        </div>
      }
    </div>
  </app-tab>
  <app-parts-view [defectId]='-1' [vehicleId]='this.vehicle.id' [allowLink]='this.allowLink'></app-parts-view>
</app-tabs>


<!-- <div class="row">
<div class="col-9">


</div>
<div class="col-3 border-left"> -->
  <!-- <h5>Paired Assets</h5>
  <p>Assets can be Linked in Asset Register</p>
  <ng-container *ngIf='!this.formSettings.allowLink && this.linkedAssets.length > 0'>
    <table class='table table-bordered'>
      <thead class='thead-dark'>
        <tr>
          <th>Asset</th>
          <th>Description</th>
          <th>Category</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor='let item of this.linkedAssets'>
          <td>{{item.asset}}</td>
          <td>{{item.description}}</td>
          <td>{{item.category.name}}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <ng-container *ngIf='this.formSettings.allowLink'>
    <ng-container *ngIf='this.vehicle.asset.id !== null && this.vehicle.asset.id !== -1'>
      <ng-container *ngIf='this.vehicle.asset.categoryId === 1 || this.vehicle.asset.categoryId === 4' style='overflow-y:hidden;'>
        <ng-select
          [items]="this.assetList"
          bindLabel="desc"
          [multiple]="true"
          [closeOnSelect]="false"
          [compareWith]="compareById"
          placeholder="Select Child Assets"
          [(ngModel)]="this.linkedAssets.data">
          <ng-template ng-header-tmp>
            <button type="button" class="btn btn-sm btn-link" (click)="this.linkedAssets.data = this.assetList.slice()">Select All</button>
            <button type="button" class="btn btn-sm btn-link" (click)="this.linkedAssets.data = []">UnSelect All</button>
          </ng-template>
        </ng-select>
      </ng-container>
      <ng-container *ngIf='this.vehicle.asset.categoryId !== 1 && this.vehicle.asset.categoryId !== 4'>
        You can only add assets to a Vehicle.<br/>
      </ng-container>
      <ng-container *ngIf='this.vehicle.asset.parentId !== -1 && this.parentAsset !== undefined'>
        Assigned to <br/>
        <button class='btn btn-block btn-info' (click)='this.openAsset(this.parentAsset.id)'>{{this.parentAsset.asset}}</button>
      </ng-container>
    </ng-container>

    <ng-container *ngIf='this.vehicle.asset.id === null || this.vehicle.asset.id === -1'>
      Please Save asset to Pair other assets.
    </ng-container>
  </ng-container>
</div> -->
<!-- </div> -->
